exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".box{border-radius:3px;overflow:hidden;box-shadow:2px 2px 20px 1px rgba(0,0,0,.1)}.show{height:100%;width:100%;transition:all .3s;opacity:1;position:absolute}.show.hide{opacity:0;visibility:hidden}.slideSettingsBtn{color:#fff}.react-grid-item.react-grid-placeholder{background:#4a90e2!important}.slide_placeholder{position:absolute;top:0;height:100%;width:100%;border-radius:3px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?outputStyle=expanded!./client/components/Slide/Slide.scss
 ** module id = 763
 ** module chunks = 0
 **/